import { getProviderName } from '@va/dashboard/selectors/customization';
import { PageContent } from '@va/dashboard/shared/ui-layout';
import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { AddTagIcon, PencilEditIcon, UserIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import {
  CopyableSection,
  fontWeights,
  Heading3,
  IconWithBackground,
  InfoSectionItem,
  Paragraph,
  paragraphSizes,
} from '@va/ui/design-system';
import { useSelector } from 'react-redux';

const RECOMMENDATIONS_COUNT = 2;

export const OptOutLogic = () => {
  const translate = useTranslate();
  const providerName = useSelector(getProviderName);

  return (
    <PageContent>
      <div className='flex flex-col sm:w-full w-600px mx-auto'>
        <Heading3 weight={fontWeights.semibold}>{translate('all.privacyCenter.optOutLogic.title')}</Heading3>
        <Paragraph className='mt-1.5' colorClassName='text-gray-charcoal'>
          {translate('all.privacyCenter.optOutLogic.subInfo')}
        </Paragraph>
        <CopyableSection
          wrapperClassName='mt-18px'
          className='p-3!'
          label=''
          value={translate('all.privacyCenter.optOutLogic.copyButtonValue')}
          icon={<IconWithBackground className='bg-white' icon={() => <AddTagIcon color='#696969' />} />}
        />
        <Paragraph
          className='mt-1.5 mb-18px py-1.5 px-18px'
          weight={fontWeights.medium}
          colorClassName='text-gray-devilSolid'
          size={paragraphSizes.tiny}
        >
          {translate('all.privacyCenter.optOutLogic.copyButtonNote')}
        </Paragraph>
        <Paragraph className='mb-1.5' weight={fontWeights.medium}>
          {translate('all.privacyCenter.optOutLogic.ourRecommendations')}
        </Paragraph>

        <ol className='list-decimal ml-6'>
          {Array.from({ length: RECOMMENDATIONS_COUNT }).map((_, index) => (
            <li key={index}>
              <Paragraph>
                {translate(`all.privacyCenter.optOutLogic.recommendation${index + 1}`, { providerName })}
              </Paragraph>
            </li>
          ))}
        </ol>

        <InfoSectionItem
          label={translate('all.privacyCenter.optOutLogic.requestHelp')}
          className='cursor-pointer bg-white rounded-18 hover:bg-gray-concrete pr-6 mt-18px'
          title={translate('all.privacyCenter.optOutLogic.contactOurSupport')}
          icon={<IconWithBackground className='bg-white' icon={() => <UserIcon color='#696969' />} />}
          rightNode={<PencilEditIcon color='#C3C3C3' />}
          onClick={() => {
            onContactSupport();
          }}
        />
      </div>
    </PageContent>
  );
};
